// @flow
import { type SetHomepageOrder } from "./actions";
import type { HomepageOrder } from "./types";

export type State = {
  homepageOrder: HomepageOrder | null
};

export const initialState: State = {
  homepageOrder: null
};

export default (state: State = initialState, action: SetHomepageOrder) => {
  switch (action.type) {
    case "SET_HOMEPAGE_ORDER_ACTION":
      return {
        ...state,
        homepageOrder: action.payload
      };
    default: {
      return state;
    }
  }
};
